var utils = require('../../../lib/utils');
var baseTimeConfig = {
	hours: {
		min: 0,
		max: 23,
		nrOfDigits: 2,
		msFactor: 3600000
	},
	minutes: {
		min: 0,
		max: 59,
		nrOfDigits: 2,
		msFactor: 60000
	},
	seconds: {
		min: 0,
		max: 59,
		nrOfDigits: 2,
		msFactor: 1000
	},
	milliseconds: {
		min: 0,
		max: 999,
		nrOfDigits: 3,
		msFactor: 1
	}
};

module.exports = {
	model: {
		dataTIME: '', // '16:55:15.049'
		fieldCode: 'time-picker',
		config: {
			isActivated: false,
			isOptional: false,
			disabled: false,
			defaultDataTIME: '',
			timeParts: ['hours', 'minutes'], // ['hours', 'minutes', 'seconds', 'milliseconds']
			timeRange: {
				// min: '08:30:00.000',
				// max: '17:00:00.000'
			},
			maxExclusive: false,
			hours: {
				stepSize: 1,
				beforeSymbol: ''
			},
			minutes: {
				stepSize: 15,
				beforeSymbol: ':'
			},
			seconds: {
				stepSize: 15,
				beforeSymbol: ':'
			},
			milliseconds: {
				stepSize: 100,
				beforeSymbol: '.'
			},
			nativeInputConfig: {
				step: 1800,
				useDataList: false
				// useDataList: {
				// 	hours: {
				// 		min: 0,
				// 		max: 23,
				// 		list: [8, 16, 23]
				// 	},
				// 	minutes: {
				// 		min: 0,
				// 		max: 59,
				// 		list: [0,30]
				// 	}
				// }
			}
		}
	},

	events: {
		onChange: {
			type: 'change',
			action: function(event){
				var self = event.data.component;
				var $target;
				var fieldCode;
				var value;

				if(self.model.config.useNativeInputElement){
					event.preventDefault();
					event.stopImmediatePropagation();

					if(($target = $(event.target)).length > 0){
						value = $target.val()
						console.log('VAL OI :', value, 'vs', $target[0].value)
						// if(value === null) value = '00:00';
						self.setTime(value)
					}
				} else {
					// NOTE: prevent optional checkbox from being sent to top
					event.preventDefault();
					event.stopImmediatePropagation();

					if(
						self.model.config.isOptional
						&&
						($target = $(event.target)).length > 0
						&&
						(fieldCode = $target.data('fieldCode')) === 'activated'
						&&
						(value = $target.is(':checked')) !== undefined
					){
						self.model.config.isActivated = value;
						self.change(0);
					}
				}
			}
		},

		getFocus: {
			type: 'click',
			action: function(event) {
				var self = event.data.component;

				if(self.model.config.useNativeInputElement){

				} else {
					event.preventDefault();
					event.stopImmediatePropagation();

					if(self.model.config.isOptional){
						var $activationCheckbox;
						if(!$(event.target).is('[data-field-code="activated"]') && ($activationCheckbox = self.$.find('[data-field-code="activated"]')).length > 0){
							self.model.config.isActivated = !$activationCheckbox.prop('checked');
							$activationCheckbox.prop('checked', self.model.config.isActivated);
							self.change(0);
						}
					}
				}
			}
		},

		hoverIn: {
			type: 'mouseenter',
			selector: '.timePart',
			action: function(event){
				var self = event.data.component;

				if(self.model.config.useNativeInputElement){

				} else {
					if(self.model.config.disabled) return;
					var $target = $(event.target).closest('.timePart');
					var activeElement;

					if((activeElement = $target.data('timePart'))){
						var element;
						for(element in self.model.config.orderMatrix){
							if(element == activeElement){
								self.model.active[element] = true;
								self.$.addClass('active');
								$target.addClass('active');
							} else {
								self.model.active[element] = false;
							}
						}
					}
				}
			}
		},
		hoverOut: {
			type: 'mouseleave',
			selector: '.timePart',
			action: function(event){
				var self = event.data.component;

				if(self.model.config.useNativeInputElement){

				} else {
					if(self.model.config.disabled) return;
					var element;
					var $target;
					if(($target = $(event.target).closest('.timePart')).length > 0){
						$target.removeClass('active');
					}
					for(element in self.model.config.orderMatrix){
						self.model.active[element] = false;
					}
					self.$.removeClass('active');
				}
			}
		},
		hoverChange: {
			type: 'mousewheel DOMMouseScroll',
			action: function(event){
				var self = event.data.component;

				if(self.model.config.useNativeInputElement){

				} else {
					if(self.model.config.disabled || (self.model.config.isOptional && !self.model.config.isActivated)) return;
					var element;
					for(element in self.model.config.orderMatrix){
						if(self.model.active[element]){
							var diff = -1;
							if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
								diff = 1;
							}
							self.change(diff, element);
							break;
						}
					}
				}
			}
		}
	},
	methods: {
		prepare(){
			if(this.model.config.useNativeInputElement){
				if((this.model.config.nativeInputConfig || {}).useDataList){
					var dataListConfig = this.model.config.nativeInputConfig.useDataList;

					if(!dataListConfig.list){

						var hourConfig = dataListConfig.hours || {};
						var minuteConfig = dataListConfig.minutes || {};
						var hours = []
						var minutes = []
						var dataList = []
						var h, m;

						if(hourConfig.list){
							hours = hourConfig.list
						} else {
							for(h = (hourConfig.min || 0); h <= (hourConfig.max || 23); h++){
								hours.push(h)
							}
						}
						if(minuteConfig.list){
							minutes = minuteConfig.list
						} else {
							for(m = (minuteConfig.min || 0); m <= (minuteConfig.max || 59); m++){
								minutes.push(m)
							}
						}
						for(h of hours){
							for(m of minutes) {
								dataList.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`)
							}
						}

						dataListConfig.list = dataList
					}
				}
			}
		},

		change: function(diff, element, internalCall, initCall){
			if(diff === undefined) diff = 1;

			if(!element){
				element = this.model.config.orderMatrixKeys[0];
			}

			var elementOrder = this.model.config.orderMatrix[element];
			var config = this.model.config[element];
			var val = this.model.value[element];
			var nextVal = (config.stepSize * diff) + val;

			// reset in charge?
			if(diff === 0){
				if(val < 0){
					// take min value as default
					nextVal = config.min;
				} else if(nextVal % config.stepSize != 0) {
					// correct preset value if it is not within given stepSize intervals
					nextVal = Math.round(nextVal / config.stepSize) * config.stepSize;
				}
			}
			// lower limit functionality
			if (nextVal < config.min){
				if(elementOrder > 0){
					this.change(-1, this.model.config.orderMatrixKeys[elementOrder - 1], true);
				}
				nextVal = config.max + 1 - config.stepSize;
			// upper limit functionality
			} else if(nextVal > config.max){
				if(elementOrder > 0){
					this.change(1, this.model.config.orderMatrixKeys[elementOrder - 1], true);
				}
				nextVal = config.min;
			}

			this.model.value[element] = nextVal;

			if(!internalCall){
				var e;
				var absoluteTimes = this.model.config.absoluteTimes;
				absoluteTimes.value = 0;
				for(e in this.model.config.orderMatrix){
					absoluteTimes.value += this.model.value[e] * this.model.config[e].msFactor;
				}

				var newValues = false;
				var maxValuesInCharge = false;

				if(absoluteTimes.min > 0 && absoluteTimes.value < absoluteTimes.min){
					if(diff >= 0) {
						newValues = this.model.config.preparedTimeRange.min;
					} else {
						newValues = this.model.config.preparedTimeRange.max;
						maxValuesInCharge = true;
					}
				} else if(
					(absoluteTimes.max > 0)
					&&
					(
						absoluteTimes.value > absoluteTimes.max
						||
						(this.model.config.maxExclusive && absoluteTimes.value == absoluteTimes.max)
					)
				){
					if(diff <= 0){
						newValues = this.model.config.preparedTimeRange.max;
						maxValuesInCharge = true;
					} else {
						newValues = this.model.config.preparedTimeRange.min;
					}
				}

				if(newValues){
					for(e in this.model.config.orderMatrix){
						this.model.value[e] = newValues[e];
						this.prepareFormatted(newValues[e], e);
					}

					if(maxValuesInCharge && this.model.config.maxExclusive){
						this.change(-1, this.model.config.orderMatrixKeys[this.model.config.orderMatrixKeys.length - 1], true)
					}
					this.prepareTime();
					this.refreshGui();
					return;
				}
			}

			this.prepareFormatted(nextVal, element);

			if(!internalCall){
				this.prepareTime();
				this.refreshGui();

				// tell parent form that this field has been changed if necessary
				if(!this.model.config.disabled){
					var value = null, absoluteTime = 0;
					if(!this.model.config.isOptional || this.model.config.isActivated){
						value = this.model.dataTIME;
						absoluteTime = this.model.config.absoluteTimes.value;
					}
					if(!initCall || this.model.initAbsoluteTime !== absoluteTime){
						this.parent(function(parentComponent){
							parentComponent.trigger('onChildChanged', {
								fieldCode: this.model.fieldCode,
								value: value,
								additionals: {
									absoluteTime: absoluteTime
								}
							});
						});
					}
				}
			}
		},

		setAbsoluteInitTime: function(){
			this.model.initAbsoluteTime = 0;
			if(this.model.dataTIME){
				var timeParts = this.timeToParts(this.model.dataTIME);
				var timePart;
				for(timePart in timeParts){
					this.model.initAbsoluteTime += (this.model.config[timePart].msFactor * timeParts[timePart]);
				}
			}
		},

		prepareFormatted: function(value, element){
			this.model.formatted[element] = String(value || 0).padStart((this.model.config[element] || {}).nrOfDigits || 2, '0');
		},

		prepareTime: function(){
			var element;
			this.model.dataTIME = '';
			for(element in this.model.config.orderMatrix){
				this.model.dataTIME += this.model.config[element].beforeSymbol + this.model.formatted[element];
			}
		},

		refreshGui: function(){
			var element;
			if(this.model.config.useNativeInputElement){
				var value = ''
				for(element in this.model.config.orderMatrix){
					value += this.model.config[element].beforeSymbol + this.model.formatted[element];
				}

				this.model.$inputElement.val(value)
			} else {
				for(element in this.model.config.orderMatrix){
					this.model.$elements[element].html(this.model.config[element].beforeSymbol + this.model.formatted[element]);
				}
			}
		},

		timeToParts: function(time){
			var element;
			var parts = String(time).split('+');
			if(parts.length > 1){
				time = parts[0];
			}
			var elements = String(time).split(/[:\.]/);
			var elementIndex;
			var values = {};
			for(elementIndex in elements || []){
				// prevent timezones
				if(element = this.model.config.orderMatrixKeys[elementIndex]){
					values[element] = parseInt(elements[elementIndex]);
				// TODO: error really helpful?
				// } else {
				// 	throw new Error('TimePickers timeToParts error @ ' + elementIndex + ' ON ' + time);
				}
			}
			
			return values;
		},

		setTime: function(time){
			if(this.model.config.disabled) return;
			var values, element, config;
			if(time){
				values = this.timeToParts(time);
				for(element in this.model.config.orderMatrix){
					if(config = this.model.config[element]){
						this.model.value[element] = values[element];
						this.change(0, element, !config.last);
					}
				}
			}
		},

		getTime: function(){
			return {
				value: this.model.dataTIME,
				absoluteValue: (this.model.config.absoluteTimes || {}).value || 0
			};
		},

		disable: function(){
			this.model.config.disabled = true;
			this.$.addClass('disabled');
		},

		enable: function(){
			this.model.config.disabled = false;
			this.$.removeClass('disabled');
		}
	},

	hooks: {
		attach: function($element, options){
			// set activated checkbox if necessary
			if(this.model.config.isOptional && this.model.dataTIME){
				this.model.config.isActivated = true;
				$element.find('[data-field-code="activated"]').prop('checked', true);
			}

			// prepare order matrix
			if(!options.refresh){
				utils.refMerge(this.model.config, baseTimeConfig);
				this.model.config.orderMatrix = {};
				this.model.config.orderMatrixKeys = this.model.config.timeParts;
				var o;
				for(o in this.model.config.orderMatrixKeys){
					this.model.config.orderMatrix[this.model.config.orderMatrixKeys[o]] = o;
					this.model.config[this.model.config.orderMatrixKeys[o]].last = false;
				}
				this.model.config[this.model.config.orderMatrixKeys[o]].last = true;

				// prepare timeRanges
				this.model.config.preparedTimeRange = {};
				this.model.config.absoluteTimes = {};
				if(this.model.config.timeRange){
					var l;
					for(l in this.model.config.timeRange){
						this.model.config.preparedTimeRange[l] = {};
						var limit;
						if((limit = this.model.config.timeRange[l])){
							var value;
							var timePart;
							var timeParts = this.timeToParts(limit);
							this.model.config.absoluteTimes[l] = 0;
							for(timePart in timeParts || []){
								if(this.model.config.orderMatrix[timePart]){
									value = timeParts[timePart];
									this.model.config.preparedTimeRange[l][timePart] = value;
									this.model.config.absoluteTimes[l] += value * this.model.config[timePart].msFactor;
								// TODO: error really helpful?
								// } else {
								// 	throw new Error('TimePickers prepare ranges error @ ' + timePart + ' ON ' + limit);
								}
							}
						}
					}

					if(!this.model.config.preparedTimeRange.min) this.model.config.preparedTimeRange.min = {};
					if(!this.model.config.preparedTimeRange.max) this.model.config.preparedTimeRange.max = {};
					for(element in this.model.config.orderMatrix){
						if(this.model.config.preparedTimeRange.min[element] === undefined) this.model.config.preparedTimeRange.min[element] = this.model.config[element].min;
						if(this.model.config.preparedTimeRange.max[element] === undefined) this.model.config.preparedTimeRange.max[element] = this.model.config[element].max;
					}
				}
			}

			var element;
			// prepare $elements
			if(this.model.config.useNativeInputElement && !this.model.$inputElement){
				// this.model.$inputElement = $element.find('input[type="time"]');
				this.model.$inputElement = $element.find('select');
				console.log(this.model.$inputElement)
			} else if(!this.model.config.useNativeInputElement && !this.model.$elements){
				this.model.$elements = {};
				for(element in this.model.config.orderMatrix){
					this.model.$elements[element] = $element.find('.timePart[data-time-part="' + element + '"]');
				}
			}

			// init model if necessary
			if(!options.refresh){
				this.model.active = {};
				this.model.value = {};
				this.model.formatted = {};
				var config;
				var values = {};
				this.model.dataTIME = this.model.dataTIME || this.model.config.defaultDataTIME;
				if(this.model.dataTIME){
					values = this.timeToParts(this.model.dataTIME);
				}
				for(element in this.model.config.orderMatrix){
					if(config = this.model.config[element]){
						this.model.active[element] = false;
						if(this.model.dataTIME){
							this.model.value[element] = values[element];
						} else {
							this.model.value[element] = -1;
						}
					}
				}
			}

			this.setAbsoluteInitTime();

			for(element in this.model.config.orderMatrix){
				// check $elements
				if(!this.model.config.useNativeInputElement && (!this.model.$elements[element] || this.model.$elements[element].length <= 0)) {
					throw Error('TimePickers ' + element + ' Element Missing');
				} else if(this.model.config.useNativeInputElement && (!this.model.$inputElement || this.model.$inputElement.length <= 0)){
					throw Error('TimePickers ' + element + ' InputElement Missing');
				} else if(!options.refresh) {
					// refresh last element external (NOTE: range recognition and gui refresh will be respected)
					this.change(0, element, !this.model.config[element].last, this.model.config[element].last);
				}
			}
		}
	}
};